<template>
  <div class="container clinic-reports">
    <div class="row mt-4">
      <div class="col">
        <h1 class="page-title">INFORMES</h1>
      </div>
    </div>

    <div class="row form-group mt-4">
      <div class="col">
        <h3>HISTORIAL DE PRESUPUESTOS</h3>
      </div>
    </div>

    <div class="row form-group">
      <div class="col-sm-2">
        <select id="clinic_treatments_period" v-model="period" class="custom-select">
          <option value="day">Hoy</option>
          <option value="day_prior">Ayer</option>
          <option value="week">Esta semana</option>
          <option value="week_prior">Semana pasada</option>
          <option value="month">Este mes</option>
          <option value="month_prior">Mes pasado</option>
          <option value="trimester">Este trimestre</option>
          <option value="trimester_prior">Trimestre pasado</option>
          <option value="year">Este año</option>
          <option value="past_year">Año pasado</option>
          <option value="custom">Personalizado</option>
        </select>
        <label for="clinic_treatments_period" class="wabident-info">Periodo</label>
      </div>
      <!-- Custom Dates Selector -->
      <transition name="fade">
        <div class="col-sm-2" v-if="period == 'custom'">
          <input v-model="date_from" id="clinic_treatments_date_from" type="date" class="form-control" />
          <label class="wabident-info" for="clinic_treatments_date_from">Desde:</label>
        </div>
      </transition>
      <transition name="fade">
        <div class="col-sm-2" v-if="period == 'custom'">
          <input v-model="date_to" id="clinic_treatments_date_to" type="date" class="form-control" />
          <label class="wabident-info" for="clinic_treatments_date_to">Hasta:</label>
        </div>
      </transition>

      <div class="col-sm-2">
        <select id="clinic_treatments_show_category" v-model="product_category_id" class="custom-select">
          <option :value="null">Todas</option>
          <option v-for="(category, index) in product_categories" :value="category.id" :key="index">
            {{ category.name }}
          </option>
        </select>
        <label for="clinic_treatments_show_category" class="wabident-info">Unidad</label>
      </div>

      <div class="col">
        <button @click="generateQuotationsReport" class="
              btn btn-primary btn-wabident
              float-right
              d-flex
              justify-content-center
              align-items-center
            ">
          <i class="fas fa-download" style="margin-right: 24px; font-size: 24px"></i>
          Descargar XLS
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      period: 'day',
      date_from: null,
      date_to: null,
      product_category_id: null,
    }
  },
  computed: {
    product_categories() {
      if (!this.clinic) return [];
      return this.clinic.product_categories;
    },
    ...mapGetters(['clinic'])
  },
  methods: {
    generateQuotationsReport() {
      let params = new URLSearchParams({
        period: this.period,
        date_from: this.date_from,
        date_to: this.date_to,
        product_category_id: this.product_category_id
      });

      window.open(`/clinic/${this.clinic.id}/quotation_report?`+params.toString());
    }
  },
  mounted() {
  },
};
</script>

<style lang="scss">
.clinic-reports {}
</style>
